import * as Sentry from '@sentry/react';

if (window.SENTRY_DSN) {
  Sentry.init({
    dsn: window.SENTRY_DSN,
    environment: window.ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sampleRate: window.ENVIRONMENT === 'PRD' ? 1 : 0.1,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    maxBreadcrumbs: 20,
  });
}

export default Sentry;
